import settings from '@/settings'

let insert = (data, headers) => {
  return fetch(`${settings.apetrusApi}/tipospagamento/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let get = () => {
  return fetch(`${settings.apetrusApi}/tipospagamento/`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default'
  })
}

let update = (id, data, headers) => {
  return fetch(`${settings.apetrusApi}/tipospagamento/${id}/`, {
    method: 'PUT',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let deletepag = (id, headers) => {
  return fetch(`${settings.apetrusApi}/tipospagamento/${id}/`, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  insert,
  get,
  update,
  deletepag
}
